document.addEventListener('DOMContentLoaded', function (event) {

	// --- TOP / Productスライダー ------
	// if (document.querySelector('.js-product-slider')) {
	//     new Swiper('.js-product-slider', {
	// 		slidesPerView:"auto",
	// 		spaceBetween: 20,
	// 		loop: false,
	// 		scrollbar: {
	// 			el: ".c-slider-controls__bar",
	// 			draggable:true,
	// 		},
	//         breakpoints: {
	//             769: {
	//                 spaceBetween: 25
	//             },
	//         }
	// 	});
	// }


	// --- Recruitスライダーのコピースライダー ----
	if (document.querySelector('.js-recruit-slider-01') && document.querySelector('.js-recruit-slider-02')) {
		const options = {
			speed: 15000, // スライド変化時間
			loop: true,
			loopAdditionalSlides: 2,
			slidesPerView: 2,
			spaceBetween: 10,
			// centeredSlides: true,
			allowTouchMove: false, // スワイプ無効
			autoplay: {
				delay: 0, //　スライダー表示時間
				disableOnInteraction: false,
			},
			breakpoints: {
				421: {
					slidesPerView: 2.5,
				},
				569: {
					slidesPerView: 3.5,
				},
				769: {
					direction: 'vertical',
					slidesPerView: 2.5,
					spaceBetween: 30,
				},
			}
		}

		document.querySelectorAll(".js-recruit-slider-01").forEach(slider01 => {
			new Swiper(slider01, options);
		})

		const reverse = options;
		reverse.autoplay.reverseDirection = true;
		document.querySelectorAll(".js-recruit-slider-02").forEach(slider02 => {
			new Swiper(slider02, reverse);
		})

	}



	// --- achievementsスライダーのコピースライダー ----
	if (document.querySelector('.js-achievements-slider')) {
		const swiper = new Swiper('.js-achievements-slider', {
			speed: 500, // スライド変化時間
			loop: true,
			loopAdditionalSlides: 1,
			slidesPerView: 1.2,
			spaceBetween: 20,
			centeredSlides: true,
			// allowTouchMove: false, // スワイプ無効
			// autoplay: {
			//   delay: 0, //　スライダー表示時間
			//   disableOnInteraction: false,
			// },
			breakpoints: {
				// スライドの表示枚数：500px以上の場合
				569: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3.5,
					spaceBetween: 30,
				},
			},
			navigation: {	// 前後ナビゲーション
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}


	// --- TOP > IT solution ----
	// --- ドリームビジョンのITソリューションの特徴のスライダー ----
	if (document.querySelector('.js-sideScroll')) {
		const swiper = new Swiper('.js-sideScroll', {
			speed: 500,
			slidesPerView: 1.2,
			spaceBetween: 20,
			centeredSlides: true,
			loop: false,
			mousewheel: true,

			breakpoints: {
				769: {
					slidesPerView: "auto",
					spaceBetween: 0,
					centeredSlides: false,
				},
			},

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			on: {
				init: function () {
					// 初期化時に無効化（769未満ではfalseに）
					if (window.innerWidth < 769) {
						this.mousewheel.disable();
					}
				},
				resize: function () {
					// リサイズ時に有効／無効を切り替える
					if (window.innerWidth < 769) {
						this.mousewheel.disable();
					} else {
						this.mousewheel.enable();
					}
				}
			}
		});
	}


})


